import { applyAuthTokenHeader, clearLocalStorage, rolesManipulator } from 'auth';
import { Api as IdentityCenterApi } from 'identity-center-api';
import { get } from 'lodash';
import { matchPath } from 'react-router-dom';
import { BUSINESS_QUERY_PARAM } from '@/modules/common/constants/search-params.ts';
import { queryClient } from '@/modules/common/query.ts';
import { publicPages } from '@/modules/common/routes.tsx';
import { Api } from 'compliance-api';

export const api = new Api({
  baseURL: import.meta.env.VITE_API_URL,
  validateStatus: status => status >= 200 && status < 300,
});

api.instance.interceptors.request.use(
  rolesManipulator.apply_app_role_header.bind(rolesManipulator),
);

export const identityCenterApi = new IdentityCenterApi({
  baseURL: import.meta.env.VITE_IDENTITY_CENTER_API_URL,
  validateStatus: status => status >= 200 && status < 300,
});

identityCenterApi.instance.interceptors.request.use(applyAuthTokenHeader);

api.instance.interceptors.request.use(applyAuthTokenHeader);

api.instance.interceptors.response.use(null, error => {
  const isPublicAccessPage = publicPages.some(path => matchPath(path, location.pathname));
  if ([401, 419].includes(get(error, 'response.status')) && !isPublicAccessPage) {
    clearLocalStorage([BUSINESS_QUERY_PARAM]);
    queryClient.removeQueries();
    window.location.href = import.meta.env.VITE_APP_SELECTOR_URL;
  } else if ([401, 419].includes(get(error, 'response.status')) && isPublicAccessPage) {
    console.log('Public page with error 401 or 419');
    throw error;
  } else {
    throw error;
  }
});

api.instance.interceptors.request.use(config => {
  const params = new URLSearchParams(location.search);
  const businessId = params.get(BUSINESS_QUERY_PARAM);

  if (businessId) {
    config.headers['x-Business-ID'] = businessId;
  }
  return config;
});
